export interface WalletPlanIdentity {
  slug?: string | null;
  name?: string | null;
}

function normalizePlanKey(value: string | null | undefined): string {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '');
}

/**
 * Wallet-only plan discount as a whole percent. STARTER 10, PLUS 15, PRO+ 20.
 * Anything else (FREE, club/partner, unknown) is 0.
 */
export function walletPlanDiscountPercent(
  plan: WalletPlanIdentity | null | undefined,
): number {
  if (!plan) return 0;
  const slug = normalizePlanKey(plan.slug);
  const name = normalizePlanKey(plan.name);

  if (slug === 'starter' || name === 'starter') return 10;
  if (slug === 'plus' || name === 'plus') return 15;
  if (slug === 'pro-plus' || name === 'pro+' || name === 'proplus') return 20;
  return 0;
}
